import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'

export type SkeletonEditorProps = {
    titleWidth?: number | string
    bodyHeight?: number
    toolbarButtons?: number
}

export default function SkeletonEditor(props: Readonly<SkeletonEditorProps>) {
    const { titleWidth = 240, bodyHeight = 72, toolbarButtons = 7 } = props

    return (
        <Stack spacing={1} sx={{ width: '100%' }}>
            <Stack
                direction="row"
                spacing={2}
                sx={{ alignItems: 'center', justifyContent: 'space-between' }}
            >
                <Skeleton variant="text" width={titleWidth} sx={{ fontSize: '1.25rem' }} />
                <Stack direction="row" spacing={1.5}>
                    <Skeleton variant="circular" width={20} height={20} />
                    <Skeleton variant="circular" width={20} height={20} />
                </Stack>
            </Stack>

            <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
                <Stack
                    direction="row"
                    spacing={1.5}
                    sx={{
                        px: 1.5,
                        py: 1,
                        bgcolor: 'action.hover',
                        borderBottom: '1px solid',
                        borderColor: 'divider',
                    }}
                >
                    {Array.from({ length: toolbarButtons }, (_, index) => (
                        <Skeleton key={index} variant="rounded" width={18} height={18} />
                    ))}
                </Stack>
                <Box sx={{ height: bodyHeight }} />
            </Box>

            <Skeleton variant="text" width={180} sx={{ fontSize: '0.75rem' }} />
        </Stack>
    )
}
